import { Injectable } from '@angular/core'
import { io, Socket } from 'socket.io-client'

import { JwtService } from '@app/modules/auth/jwt.service'
import { ApiService } from '@shared/services/api.service'

@Injectable({ providedIn: 'root' })
export class SocketService {
  private readonly baseUrlWS: string
  private sockets: { [namespace: string]: Socket } = {}

  constructor(
    private readonly jwtService: JwtService,
    private apiService: ApiService,
  ) {
    this.baseUrlWS = apiService.baseUrlWS
  }

  connect(namespace: string, hashToken?: string): Socket {
    if (this.sockets[namespace]) {
      return this.sockets[namespace]
    }

    const token = hashToken || this.jwtService.getToken()
    const fullUrl = this.baseUrlWS.endsWith(`/${namespace}`) ? this.baseUrlWS : `${this.baseUrlWS}/${namespace}`

    const socket = io(fullUrl, {
      path: '/socket.io',
      transports: ['websocket'],
      query: { token },
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 5000,
      reconnectionDelayMax: 10000,
      timeout: 20000,
    })

    this.sockets[namespace] = socket
    return socket
  }
}
